import { Button } from 'antd';
import { HistoryBookIcon } from '@/assets/icons';
import { ProfileFormFooter } from '@/components/profile';
import { ResourceHistory } from '@/components/resource-history';
import Sidebar from '@/components/sidebar/Sidebar';
import EmployeeAdditionalPersonalInfoForm from '../../EmployeeAdditionalPersonalInfoForm';
import { PROFILE_FORM_SECTIONS } from '../../profileSections';
import { useEmployeeGeneralDataForm } from '../EmployeeGeneralDataFormContext';

/** Additional personal info and the save / cancel footer. */
export default function EmployeeFormFooter() {
  const {
    closeDrawer,
    companyData,
    drawerOpen,
    employeeId,
    form,
    discardChanges,
    handleAdditionalInfoDirtyChange,
    handleReset,
    historyOpen,
    isEdited,
    isPending,
    isProfile,
    onCancel,
    onHistoryClose,
    profileSection,
    readOnly,
    resetTrigger,
    saveTile,
    setHistoryOpen,
    t,
  } = useEmployeeGeneralDataForm();

  return (
    <>
      {isProfile ? (
        <>
          <EmployeeAdditionalPersonalInfoForm
            form={form}
            inlineSection={profileSection}
            isEdited={isEdited}
            employeeId={employeeId}
            open
            onDirtyChange={handleAdditionalInfoDirtyChange}
            resetTrigger={resetTrigger}
            market={companyData?.market || 'RS'}
          />

          {!readOnly && PROFILE_FORM_SECTIONS.includes(profileSection) && (
            <ProfileFormFooter
              isPending={isPending}
              onSave={saveTile}
              onCancel={() => {
                discardChanges();
                onCancel?.();
              }}
            />
          )}
        </>
      ) : (
        <>
          <div className="form-footer form-footer--sticky !grid-cols-1">
            <div className="flex w-full items-center justify-between gap-2">
              {/* History button on the left */}
              <div className="flex">
                {isEdited && employeeId && (
                  <Button
                    type="default"
                    onClick={() => setHistoryOpen(true)}
                    className="btn-default btn-default--hover"
                  >
                    <span className="flex items-center gap-2">
                      <HistoryBookIcon style={{ fontSize: '18.2px' }} />
                      {t('history', { ns: 'forms' })}
                    </span>
                  </Button>
                )}
              </div>

              {/* Action buttons on the right */}
              <div className="flex gap-2">
                <Button
                  type="default"
                  disabled={isPending}
                  className="btn-default btn-default--hover"
                  onClick={handleReset}
                >
                  {t('reset', { ns: 'forms' })}
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isPending}
                  disabled={isPending}
                  className="btn-primary"
                >
                  {t(isEdited ? 'save' : 'submit', { ns: 'forms' })}
                </Button>
              </div>
            </div>
          </div>

          <Sidebar
            title={t('formValidation.additionalPersonalInfo', { ns: 'forms' })}
            open={drawerOpen}
            onClose={closeDrawer}
            placement="right"
          >
            <EmployeeAdditionalPersonalInfoForm
              form={form}
              onClose={closeDrawer}
              isEdited={isEdited}
              employeeId={employeeId}
              open={drawerOpen}
              onDirtyChange={handleAdditionalInfoDirtyChange}
              resetTrigger={resetTrigger}
              market={companyData?.market || 'RS'}
            />
          </Sidebar>

          {/* History Sidebar */}
          {isEdited && employeeId && (
            <Sidebar
              open={historyOpen}
              onClose={onHistoryClose}
              title={t('history', { ns: 'forms' })}
              placement="right"
              className="max-w-xl"
            >
              <ResourceHistory modelName="Employee" documentId={employeeId} />
            </Sidebar>
          )}
        </>
      )}
    </>
  );
}
